import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { getShowAllHref } from 'utils/helpers';

import { ShowAllText } from './ShowAll.styled';

type Props = {
  totalCount: number;
  route: string;
};

const SHOW_ALL_MIN_NUMBER = 5;

export const ShowAll = ({ totalCount, route }: Props) => {
  const router = useRouter();
  if (totalCount > SHOW_ALL_MIN_NUMBER) {
    return (
      <Link href={getShowAllHref(route, ['categories'])(router)} passHref>
        <a>
          <ShowAllText>Bekijk meer ({totalCount})</ShowAllText>
        </a>
      </Link>
    );
  }
  return null;
};
